import { Navigate, useLocation } from "react-router-dom";

import { useAuthStore } from "@/store/auth";

export function RequireAuth({ children }: { children: React.ReactNode }) {
  const loaded = useAuthStore((s) => s.loaded);
  const user = useAuthStore((s) => s.user);
  const location = useLocation();

  if (!loaded) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "grid",
          placeItems: "center",
          color: "var(--mute)",
          fontFamily: "var(--font-mono)",
          fontSize: 12,
        }}
      >
        loading…
      </div>
    );
  }

  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  // Profile completion is purely opt-in for everyone (admin + employee).
  // Users find /settings/profile via the Settings page when they want to
  // fill it in. No hard redirect gate anywhere in the app.
  return <>{children}</>;
}
